import React from 'react';

// Ziel-Watchlist-Auswahl fuer das Kopieren von Eintraegen (Chat vom
// 2026-08-10). Kleiner, eigenstaendiger modaler Dialog: listet alle
// Watchlists ausser der aktuellen (excludeGroupId), Klick auf eine loest
// onSelect(groupId) aus. Bewusst leichtgewichtig (eigenes Overlay statt der
// grossen DialogForm), da reine Auswahl ohne Formular.
//
// props: x, title, excludeGroupId, onSelect(groupId), onClose().
export default function MarketdataWatchlistCopyMenu(props) {
	const x = props.x;
	const [groups, setGroups] = React.useState(null);

	React.useEffect(() => {
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataWatchlistGroupList', {}, (result) => {
			if (result.data.returncode === 1) {
				setGroups(result.data.content || []);
			} else {
				setGroups([]);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const targets = (groups || []).filter((g) => String(g.groupid) !== String(props.excludeGroupId));

	return (
		<div className="marketdata-copy-overlay" onClick={props.onClose}>
			<div className="marketdata-copy-menu" onClick={(e) => e.stopPropagation()}>
				<div className="marketdata-copy-menu-head">
					<span>{props.title || 'In Watchlist kopieren'}</span>
					<i className="bi bi-x-lg marketdata-copy-menu-close" title="Schließen" onClick={props.onClose}></i>
				</div>
				{groups === null && <p className="marketdata-copy-menu-hint">Lade…</p>}
				{groups !== null && targets.length === 0 &&
					<p className="marketdata-copy-menu-hint">Keine andere Watchlist vorhanden.</p>
				}
				{targets.map((g) => (
					<button
						type="button"
						key={g.groupid}
						className="marketdata-copy-menu-item"
						onClick={() => props.onSelect(g.groupid)}
					>
						{g.name}
					</button>
				))}
			</div>
		</div>
	);
}
